import type { ERouteNamespace } from '@modules/core/services/router/enums';
import type { IFormPlainDataListboxItem } from '@modules/forms/types';

export type IRolesNamespaces = ERouteNamespace.ADMIN | ERouteNamespace.AFFILIATE;

export interface INamespace {
  namespace: IRolesNamespaces;
}

export interface IRole {
  id: number;
  name: string;
}

export interface IRolesAndTreeResponse {
  list: IRole[];
  permissions_tree: IRolePermissionsData;
}

export type IListReportNamesData = Record<IRolesNamespaces, string[]>;

export interface IListReportNamesResponse {
  list_report_fields: IListReportNamesData;
}

export interface IReportFieldsResponse {
  fields: IFormPlainDataListboxItem<string>[];
  locale_key: string;
}

export interface IReportFieldsPayload {
  id: number;
  report_name: string;
  namespace: 'role';
}

export type IRolePermissionsData = Record<string, string[]>;

export interface IRolePermissionsResponse {
  permissions_tree: IRolePermissionsData;
}

export interface IReportColumnPayload extends IReportFieldsPayload {
  value: string;
  search?: string;
}

// Create Role
export const nameField = 'name' as const;
export const copyRoleField = 'copy_permissions_from_role_id' as const;

export interface ICreateRoleForm {
  [nameField]: string;
  [copyRoleField]?: number;
}

export interface ICreateRolePayload {
  role: ICreateRoleForm & INamespace;
}

export interface ICreateRoleResponse {
  role: IRole;
}

// Save Role Permissions
export interface ISaveRolePermissionsPayload {
  actions: string[];
  controller_name: string;
}
